'use client';

import React from 'react';
import { cn } from '@/lib/utils';

interface TwitterViewIconProps {
  size?: number;
  className?: string;
}

const TwitterViewIcon: React.FC<TwitterViewIconProps> = ({
  size = 16,
  className,
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
      {...props}
    >
      <path
        d="M5.83334 14V2H7.16667V14H5.83334ZM12 14V5.66667H13.3333V14H12ZM2.66667 14L2.66934 7.33333H4.00267L4.00001 14H2.66667ZM8.83201 14V9.33333H10.1653V14H8.83201Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default TwitterViewIcon;
